var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 299,
    viewBox: "0 0 171 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9512 150.3C111.451 144.9 145.351 129.9 159.451 107.7C169.351 92.7 170.851 75.3 163.651 59.1C152.551 33.3 120.451 12 84.7512 5.69999C80.2512 5.09998 31.3512 0.899983 19.0512 2.69998H0.451172V297.3L20.5512 296.7C35.2512 298.2 80.5512 294.3 84.4512 293.7C120.151 288 152.251 266.4 163.651 240.6C170.551 224.4 169.351 207 159.451 192C142.651 165.6 100.351 153.6 76.9512 150.3ZM20.2512 18.6C31.3512 17.1 79.0512 21 82.0512 21.6C112.651 27 139.951 44.7 149.251 65.4C154.351 77.4 153.151 88.2 146.251 99.3C131.851 121.5 87.4512 135.9 16.3512 141.9V18.6H20.2512ZM148.951 234C139.951 254.7 112.351 272.7 81.7512 277.8C78.4512 278.4 34.6512 282 21.1512 280.8H20.8512L16.3512 281.1V158.4C44.5512 161.1 124.951 168.3 146.251 200.4C153.151 211.5 154.351 222.3 148.951 234Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperB);
export default __webpack_public_path__ + "static/media/UPPER_B.676ef3c0a3a6af77e7d3b5c70639c88b.svg";
export { ForwardRef as ReactComponent };